import React from 'react';
import styled from 'styled-components';
import CustomLabel from '../label/CustomLabel';
import { useState } from 'react';
import { useEffect } from 'react';


const CheckBoxInputBlock = styled.div`
    display: inline-block;
    margin: ${props => props.margin || '0px 0px'};
`;

const CheckBoxBtnBlock = styled.input`
    display: inline-block;
    cursor: pointer;
    right: 5px;
    width: 26px;
    height: 26px;
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    vertical-align: middle;
    background-size: cover;
    &:focus {
        border: 0px solid #ffc742;
        outline: 0
    }
    border-color: transparent;
    background-color: transparent;
`;

const CheckBoxPopupBtnBlock = styled.button`
    position: absolute;
    right: 0;
    color: #111;
    font-size: 14px;
    text-decoration: underline;
    padding-top: 5px;
`;

const CheckBoxInput = ({ title, onClick, margin, defaultValue, popup, popupClick, labelmargin = "0px 0px 0px 20px" }) => {

    const [checked, setChecked] = useState(defaultValue);

    useEffect(() => {
        setChecked(defaultValue);
    }, [checked, defaultValue])

    const handleClick = () => {
        onClick(!checked);
    }

    return (
        <CheckBoxInputBlock margin={margin}>
            <CheckBoxBtnBlock
                type="checkbox"
                onClick={handleClick}
                img={checked ? "/assets/images/icon/cc-icon-checked.png" : "/assets/images/icon/cc-icon.png"} />
            <CustomLabel margin={labelmargin}
                color="#666"
                onClick={handleClick}
                fontSize="14px" vAlign="middle"
                text={title} display="inline" />
            {
                popup ? <CheckBoxPopupBtnBlock onClick={popupClick}>보기</CheckBoxPopupBtnBlock> : ''
            }


        </CheckBoxInputBlock>
    );
};

export default CheckBoxInput;